<template>
  <div id="app">
    <template v-if="isAuthenticated">
      <Header @logout="logout" />
      <RouterView name="subheader" />
    </template>

    <div class="main-router-view" :class="{ authenticated: isAuthenticated }">
      <RouterView />
    </div>

    <Alerts />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { onMounted, watch } from 'vue';

import { useAuthStore } from '@tallo/auth';
import { Alerts } from '@tallo/design-system';
import { useNavigation } from '@tallo/investor/navigation';

import Header from './components/root/header.vue';
import appInitService from './services/app-init.service';

const authStore = useAuthStore();
const { openSignIn } = useNavigation();
const { isAuthenticated } = storeToRefs(authStore);

function logout() {
  authStore.logout();
  openSignIn();
}

onMounted(() => {
  authStore.setupAuthenticatedFlag();
  authStore.initializeGoogleSignInClient();
});

watch(isAuthenticated, () => {
  if (isAuthenticated.value) {
    appInitService.initApp();
  } else {
    appInitService.reset();
  }
});
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

#app {
  display: flex;
  flex-direction: column;
  height: 100%;

  .main-router-view {
    flex: 1 0 auto;

    &.authenticated {
      flex: 1;
      width: 100%;
      padding: var(--t-spacing-sm) 0 0;

      @include tablet-start {
        padding: var(--t-spacing-md);
      }

      @include desktop {
        padding: var(--t-spacing-lg);
      }
    }
  }
}
</style>
